import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withRouter } from '../../common/withRouter';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';

const reportCardStyle = {
  backgroundColor: 'white',
  border: '1px solid #e5e5e5',
  padding: '1.2rem',
  textDecoration: 'none',
  color: 'inherit',
  display: 'block',
};

const reports = [
  {
    title: 'Historical Sales Report',
    description: 'Sales report for data before 1 July 2024',
    path: '/sales-report',
  },
  {
    title: 'New Sales Report',
    description: 'Sales report from 1 July 2024 onwards',
    path: '/sales-report-new',
  },
  {
    title: 'Settlement Report',
    path: '/transaction-report',
  },
  {
    title: 'Seasonal Court Reports',
    path: '/seasonal-court-report',
  },
];

class ReportsInternal extends React.Component {
  render() {
    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <PageTop
              documentTitle='Reports'
              documentDescription='Reports'
            />
            <h2 className='main-page-header'>
              Reports
            </h2>

            <div className="card-list">
              {reports.map((report) => (
                <Link
                  key={report.path}
                  to={report.path}
                  className="card-list-item card-size-small card-margin-small"
                  style={reportCardStyle}
                >
                  <h4 style={{ marginBottom: report.description ? '0.5rem' : 0 }}>{report.title}</h4>
                  {report.description && <p style={{ margin: 0, color: '#666', fontSize: '0.9em' }}>{report.description}</p>}
                </Link>
              ))}
            </div>

          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Reports = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(ReportsInternal)
));

Reports.requiresLogin = true;
Reports.propTypes = { isLoggedIn: PropTypes.bool };

export default Reports;
